import styled, { keyframes } from 'styled-components';

const growY = keyframes`
  from {
    transform: scaleY(0);
  }
  to {
    transform: scaleY(1);
  }
`;

const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
export const DialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: var(--z-modal);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DialogContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  background-color: var(--color-white);
  z-index: calc(var(--z-modal) + 1);
  display: flex;
  flex-direction: row;
  overflow: hidden;
`;

export const DialogSidebar = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 25vw;
  max-width: 320px;
  align-items: center;
  padding: var(--spacing-6);
  background-color: var(--color-white);
  border-right: 1px solid var(--color-gray-100);
  box-shadow: var(--shadow-sm);
  z-index: 1;
  overflow: hidden;

  @media (max-width: 1200px) {
    width: 30vw;
    max-width: 280px;
  }

  @media (max-width: 1024px) {
    width: 35vw;
    max-width: 240px;
    padding: var(--spacing-5);
  }

  @media (max-width: 768px) {
    width: 80px;
    min-width: 80px;
    padding: var(--spacing-4);
  }
`;

export const DialogHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-6);
  background-color: var(--color-white);
  border-bottom: 1px solid var(--color-gray-200);
  box-shadow: var(--shadow-sm);
  z-index: 1;
  position: sticky;
  top: 0;

  @media (max-width: 1024px) {
    padding: var(--spacing-5);
  }

  @media (max-width: 768px) {
    padding: var(--spacing-4);
  }
`;

export const DialogContentWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const DialogTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
`;

export const HotelName = styled.h1`
  font-size: var(--font-size-22);
  font-weight: var(--font-weight-semibold);
  color: var(--color-gray-800);
  margin: 0;
  line-height: var(--line-height-32);

  @media (max-width: 1024px) {
    font-size: var(--font-size-20);
    line-height: var(--line-height-28);
  }

  @media (max-width: 768px) {
    font-size: var(--font-size-18);
    line-height: var(--line-height-24);
  }
`;

export const HotelLocation = styled.p`
  font-size: var(--font-size-14);
  color: var(--color-gray-600);
  margin: 0;
  line-height: var(--line-height-18);
`;

export const DialogActions = styled.div`
  display: flex;
  gap: var(--spacing-2);
  align-items: center;
`;

export const DialogBody = styled.div`
  flex: 1;
  display: flex;
  overflow: auto;
  background-color: var(--color-bg-1);
  padding: var(--spacing-6) var(--spacing-12);

  @media (max-width: 1024px) {
    padding: var(--spacing-5) var(--spacing-8);
  }

  @media (max-width: 768px) {
    padding: var(--spacing-4) var(--spacing-6);
  }
`;

export const StepsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 280px;
  flex: 1;
  overflow: hidden;
  margin-top: var(--spacing-10);

  @media (max-width: 1200px) {
    width: 240px;
    margin-top: var(--spacing-8);
  }

  @media (max-width: 1024px) {
    width: 200px;
    margin-top: var(--spacing-6);
  }

  @media (max-width: 768px) {
    width: 100%;
    margin-top: var(--spacing-4);
  }
`;

export const StepList = styled.ol`
  list-style: none;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
  overflow-y: auto;
  flex: 1;

  @media (max-width: 1024px) {
    gap: var(--spacing-3);
  }

  @media (max-width: 768px) {
    gap: var(--spacing-2);
  }
`;

export const StepItem = styled.li<{
  $isActive?: boolean;
  $isCompleted?: boolean;
  $isDisabled?: boolean;
}>`
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
  padding: var(--spacing-3);
  padding-left: var(--spacing-1);
  border-radius: var(--radius-lg);
  transition: var(--transition-fast);
  // cursor: ${({ $isDisabled, $isActive }) => ($isDisabled && !$isActive ? 'not-allowed' : 'pointer')};
  // background-color: ${({ $isActive }) =>
    $isActive ? 'var(--color-primary-50)' : 'transparent'};

 // &:hover {
    //background-color: ${({ $isActive }) =>
      $isActive ? 'var(--color-primary-50)' : 'var(--color-gray-50)'};
  }

  @media (max-width: 1024px) {
    gap: var(--spacing-2);
    padding: var(--spacing-2);
    padding-left: var(--spacing-1);
  }

  @media (max-width: 768px) {
    padding: var(--spacing-2);
    padding-left: var(--spacing-1);
    justify-content: center;
  }
`;

export const StepIcon = styled.div<{
  $isActive?: boolean;
  $isCompleted?: boolean;
  $isDisabled?: boolean;
}>`
  width: 40px;
  height: 40px;
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-14);
  font-weight: var(--font-weight-medium);
  flex-shrink: 0;
  position: relative;
  z-index: 1;
   cursor: ${({ $isDisabled, $isActive }) => ($isDisabled && !$isActive ? 'not-allowed' : 'pointer')};

  border: ${({ $isActive, $isCompleted }) => {
    if ($isActive) return 'none';
    return '1px solid var(--color-gray-400)';
  }};

  background-color: ${({ $isActive, $isCompleted }) => {
    if ($isActive) return 'var(--color-primary-600)';
    return 'var(--color-white)';
  }};

  color: ${({ $isActive, $isCompleted }) =>
    $isActive ? 'var(--color-white)' : 'var(--color-gray-400)'};

  @media (max-width: 768px) {
    width: 36px;
    height: 36px;
    font-size: var(--font-size-12);
  }
`;

export const StepConnector = styled.div<{
  $isActive?: boolean;
  $isFlowing?: boolean;
  $isCompleted?: boolean;
}>`
  width: 2px;
  height: calc(100% + 2px);
  background: var(--color-gray-200);
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  overflow: hidden;

  .connector-fill {
    width: 100%;
    height: 100%;
    background: var(--color-primary-600);
    transform-origin: top;
    animation: ${growY} 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }

  @media (max-width: 768px) {
    width: 2px;
  }
`;

export const StepContent = styled.div`
  min-width: 0;
  max-width: fit-content;
  display: flex;
  flex: 1;
  align-items: center;
  gap: var(--spacing-1);
  svg {
    align-self: flex-start;
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const StepTitle = styled.h3<{
  $isActive?: boolean;
  $isCompleted?: boolean;
  $isDisabled?: boolean;
}>`
  min-width: 0;
  font-size: var(--font-size-14);
  font-weight: var(--font-weight-medium);
  color: ${({ $isActive, $isCompleted }) =>
    $isActive || $isCompleted
      ? 'var(--color-gray-800)'
      : 'var(--color-gray-500)'};
       cursor: ${({ $isDisabled, $isActive }) => ($isDisabled && !$isActive ? 'not-allowed' : 'pointer')};
  margin: 0;
  line-height: var(--line-height-18);
  word-break: break-word;
  white-space: break-spaces;
  hyphens: auto;
  text-transform: capitalize;

  @media (max-width: 1024px) {
    font-size: var(--font-size-13);
    line-height: var(--line-height-16);
  }
`;

export const StepDescription = styled.p`
  font-size: var(--font-size-14);
  color: var(--color-gray-500);
  margin: 0;
  line-height: var(--line-height-18);
  margin-top: var(--spacing-1);
`;

export const ProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  margin-bottom: var(--spacing-6);
  flex-shrink: 0;
  h1 {
    font-size: var(--font-size-18);
    font-weight: var(--font-weight-semibold);
    color: var(--color-gray-800);
    line-height: var(--line-height-27);
    margin-bottom: var(--spacing-2);
  }
  p {
    font-size: var(--font-size-16);
    color: var(--color-gray-500);
    line-height: var(--line-height-21);
    font-weight: var(--font-weight-medium);
  }

  @media (max-width: 1024px) {
    margin-bottom: var(--spacing-4);
    h1 {
      font-size: var(--font-size-16);
      line-height: var(--line-height-24);
      margin-bottom: var(--spacing-1);
    }
    p {
      font-size: var(--font-size-14);
      line-height: var(--line-height-18);
    }
  }

  @media (max-width: 768px) {
    gap: var(--spacing-1);
    margin-bottom: var(--spacing-3);
    align-items: center;
    h1 {
      display: none;
    }
    p {
      font-size: var(--font-size-11);
      line-height: var(--line-height-14);
      text-align: center;
      font-weight: var(--font-weight-semibold);
      color: var(--color-gray-600);
    }
  }
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background-color: var(--color-gray-200);
  border-radius: var(--radius-full);
  overflow: hidden;

  @media (max-width: 768px) {
    height: 4px;
    width: 100%;
  }
`;

export const ProgressFill = styled.div<{ $progress: number }>`
  height: 100%;
  background-color: var(--color-primary-600);
  border-radius: var(--radius-full);
  width: ${({ $progress }) => $progress}%;
  transition: var(--transition-normal);
`;

//Warapper of tabs and content
export const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-8);
  width: 100%; /* Take full width */
  height: 100%;
`;

export const TabsContainer = styled.div`
  display: flex;
  align-items : center;
  gap : var(--spacing-8);
  align-self: start;
  max-width: 70vw;
  width: 100%;

  @media (max-width: 1200px) {
    max-width: 75vw;
    gap: var(--spacing-6);
  }

  @media (max-width: 1024px) {
    max-width: 80vw;
    gap: var(--spacing-4);
  }

  @media (max-width: 768px) {
    max-width: 100%;
    gap: var(--spacing-3);
  }
`;

export const TabsList = styled.div`
  display: flex;
  gap: var(--spacing-8);
  border-bottom: 1px solid var(--color-gray-200);
  width: fit-content;
  position: relative;

  @media (max-width: 1024px) {
    gap: var(--spacing-6);
  }

  @media (max-width: 768px) {
    gap: var(--spacing-4);
  }
`;

export const TabItem = styled.button<{
  $showBorder?: boolean;
  $isActive?: boolean;
  $isDisabled?: boolean;
}>`
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  padding: 0 0  var(--spacing-4) 0;
  border: none;
  background: transparent;
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
  transition: var(--transition-fast);
  position: relative;
  font-size: var(--font-size-16);
  font-weight: ${({ $isActive }) =>
    $isActive  ? 'var(--font-weight-semibold)' : 'var(--font-weight-medium)'};
  white-space: nowrap;
  border-bottom: ${({ $isActive, $showBorder = false }) =>
    $isActive && $showBorder ? '3px solid var(--color-primary-600)' : '3px solid transparent'};

  color: ${({ $isActive, $isDisabled }) => {
    if ($isDisabled) return 'var(--color-gray-300)';
    if ($isActive) return 'var(--color-primary-600)';
    return 'var(--color-gray-600)';
  }};

  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }

  @media (max-width: 1024px) {
    font-size: var(--font-size-14);
    padding: var(--spacing-3) 0;
    gap: var(--spacing-1);
    
    svg {
      width: 14px;
      height: 14px;
    }
  }

  @media (max-width: 768px) {
    font-size: var(--font-size-13);
    padding: var(--spacing-2) 0;
  }
`;

export const TabIndicator = styled.div<{ $left: number; $width: number }>`
  position: absolute;
  bottom: -1px;
  left: ${({ $left }) => $left}px;
  width: ${({ $width }) => $width}px;
  height: 3px;
  background-color: var(--color-primary-600);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 2px 2px 0 0;
`;

export const TabIcon = styled.span<{
  $isActive?: boolean;
  $isDisabled?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ContentContainer = styled.div`
  width: 100%;
  height: 100%;
  min-height: fit-content;
  min-width: 800px;
  max-width: 70vw;
  box-sizing: border-box;
  padding-bottom: var(--spacing-6);

  @media (max-width: 1200px) {
    max-width: 75vw;
    min-width: 600px;
  }

  @media (max-width: 1024px) {
    max-width: 80vw;
    min-width: 500px;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    min-width: auto;
  }
`;

export const StepHeader = styled.div`
  margin-bottom: var(--spacing-8);
`;

export const StepTitle2 = styled.h2`
  font-size: var(--font-size-28);
  font-weight: var(--font-weight-bold);
  color: var(--color-gray-900);
  margin: 0;
  line-height: var(--line-height-32);
  letter-spacing: var(--letter-spacing-h2);
`;

export const StepSubtitle = styled.p`
  font-size: var(--font-size-16);
  color: var(--color-gray-600);
  margin: var(--spacing-2) 0 0 0;
  line-height: var(--line-height-24);
`;

export const NavigationFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-6);
  background-color: var(--color-white);
  border-top: 1px solid var(--color-gray-200);
  margin-top: auto;
`;

export const BackButton = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  margin-bottom: var(--spacing-6);
  cursor: pointer;
  align-self: flex-start;
  flex-shrink: 0;

  h2 {
    font-size: var(--font-size-16);
    font-weight: var(--font-weight-medium);
    color: var(--color-gray-600);
    line-height: var(--line-height-21);
    margin: 0;
  }

  &:hover {
    h2 {
      color: var(--color-gray-800);
    }
  }

  @media (max-width: 1024px) {
    margin-bottom: var(--spacing-4);
    h2 {
      font-size: var(--font-size-14);
      line-height: var(--line-height-18);
    }
  }

  @media (max-width: 768px) {
    margin-bottom: var(--spacing-4);
    h2 {
      display: none;
    }
  }
`;

export const CloseButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: var(--radius-lg);
  border: none;
  background-color: transparent;
  color: var(--color-gray-500);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: var(--transition-fast);

  &:hover {
    background-color: var(--color-gray-100);
    color: var(--color-gray-700);
  }

  &:focus {
    outline: 2px solid var(--color-primary-600);
    outline-offset: 2px;
  }
`;

// Loader and Error Dialog Components
export const LoaderErrorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
  flex-direction: column;
  gap: var(--spacing-4);
`;

export const LoaderSpinner = styled.div`
  width: 32px;
  height: 32px;
  border: 3px solid var(--color-gray-200);
  border-top: 3px solid var(--color-primary-600);
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

export const LoaderText = styled.p`
  color: var(--color-gray-600);
  font-size: var(--font-size-16);
  margin: 0;
`;

export const ErrorIcon = styled.div`
  font-size: var(--font-size-32);
`;

export const ErrorText = styled.p`
  color: var(--color-error);
  font-size: var(--font-size-16);
  margin: 0;
`;

// Sliding Panel Components
export const SlidingPanelOverlay = styled.div<{
  $isOpen: boolean;
  $isClosing: boolean;
  $isOpening: boolean;
}>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: calc(var(--z-modal) + 2);
  display: ${({ $isOpen, $isClosing }) =>
    $isOpen || $isClosing ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;
  opacity: ${({ $isOpen, $isClosing, $isOpening }) =>
    $isOpen && !$isClosing && !$isOpening ? 1 : 0};
  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`;

export const SlidingPanelContainer = styled.div<{
  $isOpen: boolean;
  $isClosing: boolean;
  $isOpening: boolean;
}>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 60vw;
  max-width: 1200px;
  background-color: var(--color-white);
  z-index: calc(var(--z-modal) + 3);
  display: flex;
  flex-direction: column;
  box-shadow: var(--shadow-lg);
  transform: ${({ $isOpen, $isClosing, $isOpening }) => {
    if (!$isOpen) return 'translateX(100%)';
    if ($isOpening) return 'translateX(100%)';
    if ($isClosing) return 'translateX(100%)';
    return 'translateX(0)';
  }};
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`;

export const SlidingPanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-6);
  background-color: var(--color-white);
  border-bottom: 1px solid var(--color-gray-200);
  box-shadow: var(--shadow-sm);
`;

export const SlidingPanelTitle = styled.h1`
  font-size: var(--font-size-22);
  font-weight: var(--font-weight-bold);
  color: var(--color-gray-800);
  margin: 0;
  line-height: var(--line-height-32);
`;

export const SlidingPanelCloseButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: var(--radius-full);
  border: none;
  background-color: var(--color-gray-100);
  color: var(--color-gray-500);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: var(--transition-fast);

  &:hover {
    background-color: var(--color-gray-200);
    color: var(--color-gray-700);
  }

  &:focus {
    outline: 2px solid var(--color-primary-600);
    outline-offset: 2px;
  }
`;

export const SlidingPanelBody = styled.div`
  flex: 1;
  padding: var(--spacing-2) var(--spacing-6);
  overflow-y: auto;
  background-color: var(--color-white);
`;
